// extracted by mini-css-extract-plugin
export default {"autoSizer":"style__autoSizer___CgRJw"};